import { gate } from 'hub-http/gates';
import withGateOverride from './withGateOverride';
import { resolveIsUngated } from '../utils/UserInfoHelper';
export const SAME_OBJECT_TYPE_ASSOCIATIONS = 'same-type-object-associations';
export const NEW_ILS_TIME_FILTERS = 'new-ils-time-filters';
export const LEGACY_CTA_SUNSET = 'CtasSunset:LimitAccessInFilters';
export const PROPERTY_COMPARISONS = 'crm:filters:crmsearchPropertyComparisions';
export const FIELD_OVERRIDE_V2 = 'crm:filters:fieldOverrideV2';
export const DYNAMIC_DATE_FILTERS = 'CRM:Filters:RollingDatePoints';
export const FILTERS_REMOVE_TIMEZONE_FOR_DATES = 'Filters:RemoveTimezoneForDateFilters';
export const RESTRICT_LAST_MODIFIED_IN_PROPERTY_VALUE_CHANGED = 'Filters:PropertyValueChangedRestictions';
export const REMOVE_DEFAULT_VALUE_LOGIC = 'CRM:Filters:RemoveDefaultValue';
export const DEAL_LISTS_GATE = 'CRM:Segments:DealListsCreation';
export const DATE_TIME_HOURS_FILTERING = 'CRM:Filters:HoursFiltering';
export const DEAL_SPLIT_FILTER_GATE = 'CRM:Filters:DealSplit';
export const hasAllGates = gates => {
  const isUngated = resolveIsUngated();
  // eslint-disable-next-line hubspot-dev/no-bare-gate-strings
  return gates.every(g => isUngated(g) || isUngated(gate(g)));
};
export const hasSameObjectAssociationFiltering = isUngated => {
  return isUngated(SAME_OBJECT_TYPE_ASSOCIATIONS);
};
export const hasNewIlsTimeFiltersEnabled = isUngated => {
  return withGateOverride(NEW_ILS_TIME_FILTERS, isUngated(NEW_ILS_TIME_FILTERS));
};
export const hasLimitedLegacyCTAsAccess = isUngated => {
  return isUngated(LEGACY_CTA_SUNSET);
};
export const hasPropertyComparisons = isUngated => {
  return isUngated(PROPERTY_COMPARISONS);
};
export const hasFieldOverrideV2 = isUngated => {
  return withGateOverride(FIELD_OVERRIDE_V2, isUngated(FIELD_OVERRIDE_V2));
};
export const hasDynamicDateFilters = isUngated => {
  return isUngated(DYNAMIC_DATE_FILTERS);
};
export const hasRemoveTimezoneForDates = isUngated => {
  return isUngated(FILTERS_REMOVE_TIMEZONE_FOR_DATES);
};
export const hasPropertyValueChangedRestrictions = isUngated => {
  return isUngated(RESTRICT_LAST_MODIFIED_IN_PROPERTY_VALUE_CHANGED);
};
export const hasDateTimeHoursFiltering = isUngated => {
  return isUngated(DATE_TIME_HOURS_FILTERING);
};
export const NON_CONTACTS_CUSTOM_EVENTS = 'Filters:NonContactsCustomEvents';
export const hasNonContactsCustomEvents = isUngated => {
  return isUngated(NON_CONTACTS_CUSTOM_EVENTS);
};
export const PARTNER_ACCOUNT_LISTS_GATE = 'PartnerAccountCrmObject:ListsApp';
export const hasPartnerAccountLists = isUngated => {
  return isUngated(PARTNER_ACCOUNT_LISTS_GATE);
};
export const RELATIVE_DATE_FILTERING_CRM_ONLY = gate('Filters:RelativeDateFiltering:CRMOnly');
export const hasRelativeDateFilteringCrmOnly = isUngated => {
  return isUngated(RELATIVE_DATE_FILTERING_CRM_ONLY);
};
export const CRM_SEARCH_X_DAYS_INCLUSIVE = gate('Filters:XDaysWithExclusiveBounds');
export const hasXDaysWithExclusiveBounds = isUngated => {
  return isUngated(CRM_SEARCH_X_DAYS_INCLUSIVE);
};
export const USE_IS_EXTERNAL_OPTIONS_PROPERTY = gate('Filters:UseIsExternalOptionsProperty');
export const hasUseIsExternalOptionsProperty = isUngated => {
  return isUngated(USE_IS_EXTERNAL_OPTIONS_PROPERTY);
};
export const COMBINED_FILTER_FAMILY_AND_FIELD_SELECT_PANEL = gate('Filters:CombinedFilterFamilyAndFieldSelectPanel');
export const hasCombinedFilterFamilyAndFieldSelectPanel = isUngated => {
  return isUngated(COMBINED_FILTER_FAMILY_AND_FIELD_SELECT_PANEL);
};
export const RESET_FILTER_VALUE_LOGIC = gate('Filters:ResetFilterValueLogic');
export const hasResetFilterValueLogic = () => {
  return resolveIsUngated()(RESET_FILTER_VALUE_LOGIC);
};
export const ACTIVITY_FILTERS = 'CRM:ILSFilters:ActivityFilters';
export const hasActivityFilters = () => {
  return resolveIsUngated()(ACTIVITY_FILTERS);
};
export const DISABLE_ACTIVITY_OBJECT = gate('Filters:DisableActivityObject');
export const hasActivityObjectDisabled = () => {
  return resolveIsUngated()(DISABLE_ACTIVITY_OBJECT);
};
export const EVENT_FILTERS_FOR_NON_CONTACT_OBJECTS = gate('filters:unifiedEventsForNonContactObjects');
export const hasEventsForAllObjects = () => {
  return resolveIsUngated()(EVENT_FILTERS_FOR_NON_CONTACT_OBJECTS);
};
export const UNIFIED_EVENTS_DATE_REFINEMENTS = gate('Filters:UnifiedEventDateRefinements');
export const hasUnifiedEventsDateRefinements = () => resolveIsUngated()(UNIFIED_EVENTS_DATE_REFINEMENTS);
export const PERCENTAGE_QUICK_FILTER = gate('Filters:PercentageQuickFilter');
export const hasPercentageQuickFilter = () => {
  return resolveIsUngated()(PERCENTAGE_QUICK_FILTER);
};
export const ALL_DEACTIVATED_OWNERS = gate('Filters:AllDeactivatedOwners');
export const hasAllDeactivatedOwnersFilter = () => {
  return resolveIsUngated()(ALL_DEACTIVATED_OWNERS);
};
export const ANNIVERSARY_FILTERING = gate('Filters:AnniversaryFilters');
export const hasAnniversaryFiltering = () => resolveIsUngated()(ANNIVERSARY_FILTERING);
export const FILTERS_INTEGRATOR_EVENTS = gate('filters:integratorEvents');
export const ungatedForIntegratorEvents = () => resolveIsUngated()(FILTERS_INTEGRATOR_EVENTS);
export const FLEXIBLE_LOGIC_GROUPS = gate('Filters:FlexibleLogicGroupConditions');
export const hasFlexibleLogicGroupConditions = () => resolveIsUngated()(FLEXIBLE_LOGIC_GROUPS);
export const CATEGORY_BASED_PROPERTY_SELECT = gate('Filters:CategoryBasedPropertySelect');
export const hasCategoryBasedPropertySelect = () => resolveIsUngated()(CATEGORY_BASED_PROPERTY_SELECT);
export const PROPERTY_INFORMATION_POPOVER = gate('Filters:PropertyInformationPopover');
export const hasPropertyInformationPopover = () => resolveIsUngated()(PROPERTY_INFORMATION_POPOVER);
export const TIMEZONE_INPUT_ENABLED = gate('Filters:TimeZoneInputEnabled');
export const hasTimeZoneInputEnabled = () => resolveIsUngated()(TIMEZONE_INPUT_ENABLED);
export const OCCURRED_AT_REMOVED = gate('ILS:MigrateUEListsDateRefinements');
export const hasOccurredAtRemoved = () => resolveIsUngated()(OCCURRED_AT_REMOVED);